<template lang='pug' src='./Navbar.pug'></template>

<script>
  import Filters from '../../components/Filters/Filters'
  import Username from '../../components/Username/Username'

  export default {
    name: 'Navbar',
    components: {
      Filters,
      Username
    }
  }
</script>

<style lang='css' src='./Navbar.css' scoped></style>



// WEBPACK FOOTER //
// Navbar.vue?5239d5c9